/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_Account_CreationInputs */



/**
* | output |
* | --- |
* | "Account creation failed." |
*
* @param {Passkey_Error_Account_CreationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_account_creation = /** @type {((inputs?: Passkey_Error_Account_CreationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_Account_CreationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La création du compte a échoué.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La creación de la cuenta ha fallado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criação da conta falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione dell'account fallita.")
	return /** @type {LocalizedString} */ ("Account creation failed.")
});